import { createAction, handleActions } from 'redux-actions'

export const setTimeZoneOffsetAction = createAction('SET_TIME_ZONE_OFFSET')

export const timeZoneOffsetReducer = handleActions(
  {
    SET_TIME_ZONE_OFFSET: (state, action) => {
      return { offset: action.payload }
    }
  },
  { offset: -5 }
)



// WEBPACK FOOTER //
// ./src/redux/modules/timeZoneOffsetModule.js